import React from "react";
import PropTypes from "prop-types";
import inputs from "./inputs";
import FormButtons from "./FormButtons";
import WorkersTable from "./WorkersTable";
import {
  genTextFileName,
  genGroup1Text,
  genGroup2Text,
  genGroup3Text,
  genGroup4Text,
} from "./genTxt";
import { downloadFile } from "../utils";
import { addZeroToNum } from "./inputs";
import { sendNotificationApp } from "../../../../Global/actions";
import { openCloseNotifCotizaciones, sendDeclaration } from "./actions";
import { Popup } from "devextreme-react";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";
import { connect } from "react-redux";
import ModalNotif from "./ModalNotif";

// const steps = {
//   currentStep: 3,
//   step1: {
//     anoRemuneracion: 2010,
//     apellidoMaternoRL: "VALDEBENITO",
//     apellidoPaternoRL: "ARAOS",
//     calle: "asd",
//     ciudad: "asd",
//     comuna: "000000001101",
//     comunas: [],
//     correoElectronico: "azsd@as.com",
//     correoElectronicoRL: "PREVENCION@CASAROYAL.CL",
//     folio: "0071801",
//     loading: false,
//     mesRemuneracion: "Enero",
//     nombreRL: "JAIME ALEJANDRO",
//     nombreRazonSocial: "l",
//     numeroDeCalle: "123",
//     region: "01",
//     rutRL: "7312757-2",
//     rutRazonSocial: "25.778.651-K",
//     tasa: 1.27,
//     telefono: "947300200",
//     tipoRemuneracion: "Remuneración",
//     direcciones: [
//       {
//         IdRegion: "01",
//         DescripcionRegion: "I - Iquique",
//         Ciudades: [],
//         Comunas: [],
//       },
//       {
//         IdRegion: "02",
//         DescripcionRegion: "II - Antofagasta",
//         Ciudades: [],
//         Comunas: [],
//       },
//       {
//         IdRegion: "03",
//         DescripcionRegion: "III - Copiapo",
//         Ciudades: [],
//         Comunas: [],
//       },
//       {
//         IdRegion: "04",
//         DescripcionRegion: "IV - La Serena",
//         Ciudades: [],
//         Comunas: [],
//       },
//       {
//         IdRegion: "05",
//         DescripcionRegion: "V - Valparaiso",
//         Ciudades: [],
//         Comunas: [],
//       },
//       {
//         IdRegion: "06",
//         DescripcionRegion: "VI - Rancagua",
//         Ciudades: [],
//         Comunas: [],
//       },
//       {
//         IdRegion: "07",
//         DescripcionRegion: "VII - Talca",
//         Ciudades: [],
//         Comunas: [],
//       },
//       {
//         IdRegion: "08",
//         DescripcionRegion: "VIII - Concepcion",
//         Ciudades: [],
//         Comunas: [],
//       },
//       {
//         IdRegion: "09",
//         DescripcionRegion: "IX - Temuco",
//         Ciudades: [],
//         Comunas: [],
//       },
//       {
//         IdRegion: "10",
//         DescripcionRegion: "X - Puerto Montt",
//         Ciudades: [],
//         Comunas: [],
//       },
//       {
//         IdRegion: "11",
//         DescripcionRegion: "XI - Coyhaique",
//         Ciudades: [],
//         Comunas: [],
//       },
//       {
//         IdRegion: "12",
//         DescripcionRegion: "XII - Punta Arenas",
//         Ciudades: [],
//         Comunas: [],
//       },
//       {
//         IdRegion: "13",
//         DescripcionRegion: "RM - Santiago",
//         Ciudades: [],
//         Comunas: [],
//       },
//       {
//         IdRegion: "14",
//         DescripcionRegion: "XIV - Los Rios",
//         Ciudades: [],
//         Comunas: [],
//       },
//       {
//         IdRegion: "15",
//         DescripcionRegion: "XV - Arica y Parinac",
//         Ciudades: [],
//         Comunas: [],
//       },
//       {
//         IdRegion: "16",
//         DescripcionRegion: "XVI - Región de Ñuble",
//         Ciudades: [],
//         Comunas: [],
//       },
//     ],
//     regiones: [
//       { Key: "108544771952587141", Cod: "01", Text: "I - Iquique" },
//       { Key: "108544771952587142", Cod: "02", Text: "II - Antofagasta" },
//       { Key: "108544771952587143", Cod: "03", Text: "III - Copiapo" },
//       { Key: "108544771952587144", Cod: "04", Text: "IV - La Serena" },
//       { Key: "108544771952587149", Cod: "09", Text: "IX - Temuco" },
//       { Key: "1085447719525871413", Cod: "13", Text: "RM - Santiago" },
//       { Key: "108544771952587145", Cod: "05", Text: "V - Valparaiso" },
//       { Key: "108544771952587146", Cod: "06", Text: "VI - Rancagua" },
//       { Key: "108544771952587147", Cod: "07", Text: "VII - Talca" },
//       { Key: "108544771952587148", Cod: "08", Text: "VIII - Concepcion" },
//       { Key: "1085447719525871410", Cod: "10", Text: "X - Puerto Montt" },
//       { Key: "1085447719525871411", Cod: "11", Text: "XI - Coyhaique" },
//       { Key: "1085447719525871412", Cod: "12", Text: "XII - Punta Arenas" },
//       { Key: "1085447719525871414", Cod: "14", Text: "XIV - Los Rios" },
//       { Key: "1085447719525871415", Cod: "15", Text: "XV - Arica y Parinac" },
//     ],
//   },
//   step2: {
//     cotizacionAPagar: "23669",
//     diferenciaDeCotizacion: "345345",
//     interesesPenales: "809",
//     month: "Julio",
//     multas: "12",
//     reajustes: "756",
//     showDownloadTooltip: false,

//     cotizacionAPagar: "23669",
//     file: [],
//     workers: [
//       {
//         "apellido materno": "V",
//         "apellido paterno": "lmao",
//         "movimiento personal": "0",
//         nombre: "Luis",
//         "remuneracion imponible": "23423",
//         rut: "25.778.651-K",
//         sexo: "M",
//       },
//       {
//         "apellido materno": "asd",
//         "apellido paterno": "qdw",
//         "fecha inicio movimiento": "09-07-20",
//         "fecha termino movimiento": "04-07-20",
//         "movimiento personal": "5",
//         nombre: "asd",
//         "remuneracion imponible": "123",
//         rut: "25.778.651-K",
//         sexo: "F",
//       },
//       {
//         "apellido materno": "asd",
//         "apellido paterno": "qdw",
//         "fecha inicio movimiento": "05-07-20",
//         "fecha termino movimiento": "05-07-20",
//         "movimiento personal": "2",
//         nombre: "PEPE",
//         "remuneracion imponible": "123",
//         rut: "25.778.651-K",
//         sexo: "F",
//       },
//     ],
//   },
//   step3: {},
// };

class Step3 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showPopup: false,
    };
  }

  handleStepUpdate = ({ toPreviousStep }) => {
    const { updateStepValues } = this.props;
    updateStepValues("step3", {}, toPreviousStep);
  };

  blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = async () => {
        resolve(await reader.result.replace(/^data:.+;base64,/, ""));
      };
      reader.readAsDataURL(blob);
    });
  };

  genTextFile = async () => {
    const { steps } = this.props;
    //this.props.dispatch(openCloseNotifCotizaciones(true));

    const textFileName = genTextFileName();

    //let txt = [
    //  ...genGroup1Text(steps),
    //  ...genGroup2Text(steps),
    //  ...genGroup3Text(steps),
    //  ...genGroup4Text(steps),
    //];
    let objDeclaracion = {};
    objDeclaracion.GROUP1 = genGroup1Text(steps);
    objDeclaracion.GROUP2 = genGroup2Text(steps);
    objDeclaracion.GROUP3 = genGroup3Text(steps);
    objDeclaracion.GROUP4 = genGroup4Text(steps);

    //txt = txt.map((i) => i.toUpperCase());

    // * Send notification
    /*const today = new Date();
    const json = {
      personalizations: [
        {
          to: [
            {
              email: steps.step1.correoElectronicoRL,
              name: `${steps.step1.nombreRL} ${steps.step1.apellidoPaternoRL} ${steps.step1.apellidoMaternoRL}`,
            },
          ],
          subject: "Comprobante Declaración Cotizaciones ACHS",
          dynamic_template_data: {
            razon_social: steps.step1.nombreRazonSocial,
            rut_empresa: steps.step1.rutRazonSocial,
            n_trabajadores: steps.step2 && steps.step2.workers && steps.step2.workers.length
                              ? steps.step2.workers.length
                              : 0,
            total_declaraciones: `$ ${steps.step2.cotizacionAPagar}`,
            total_RIM: `$ ${(steps.step2.interesesPenales ? parseInt(steps.step2.interesesPenales) : 0) +
              (steps.step2.reajustes ? parseInt(steps.step2.reajustes) : 0) +
              (steps.step2.multas ? parseInt(steps.step2.multas) : 0)}`,
            fecha: `${addZeroToNum(today.getDate())}/${addZeroToNum(today.getMonth() + 1)}/${today.getFullYear()}`,
            hora: `${today.getHours()}:${addZeroToNum(today.getMinutes())}`,
          },
        },
      ],
      from: {
        email: "info@achs.cl",
        name: "ACHS",
      },
      template_id: "d-1ec17357a9144326947eb8a25f367af2",
    };

    this.props.dispatch(sendNotificationApp(json));

    const blob = new Blob(txt, { type: "text/plain" });

    const b64 = await this.blobToBase64(blob);

    const jsonAchs = {
      personalizations: [
        {
          to: [
            {
              email: "declaracionform@achs.cl",
              name: "declaracionform",
            },
          ],
        },
      ],
      attachments: [
        {
          content: b64,
          filename: textFileName,
          type: "text/plain",
          disposition: "attachment",
          contentId: 'mytext',
        }
      ],
      from: {
        email: "info@achs.cl",
        name: "ACHS",
      },
      template_id: "d-57d8c5a95b004868b53a9c2263432a34",
    };

    this.props.dispatch(sendNotificationApp(jsonAchs));*/


    // * Download blob as file
    // downloadFile({ blob, textFileName });
    this.props.dispatch(sendDeclaration(objDeclaracion));
  };

  getStepInputValue = (step, input) => {
    let { name } = input;
    let value = step[name];

    if (name === "region") {
      value =
        step &&
        step.regiones &&
        step.regiones.filter((r) => r.Cod === `${step.region}`)[0].Text;
    }

    return value;
  };

  render() {
    const { steps } = this.props;
    let step1and2Array = inputs.step1.concat(inputs.step2);
    let step1and2Object = {...steps.step1, ...steps.step2}

    return (
      <div id="cotizaciones-step3">
        <ModalNotif />
        <div>
          <span className="form-title" style={{marginTop: "25px"}}>Resumen de declaración</span>
          <div className="cotizaciones-step3-table">
            {step1and2Array.map((input) => {
              if (!step1and2Object[input.name]) return;

              return (
                <React.Fragment key={input.name}>
                  <b>{input.label}</b>
                  <div>{this.getStepInputValue(step1and2Object, input)}</div>

                  {input.name === "telefono" && (
                    <div className="form-separator">
                      <hr />
                    </div>
                  )}

                  {input.name === "anoRemuneracion" && (
                    <>
                      <div className="form-separator">
                        <hr />
                      </div>
                      <div className="long-grid" style={{paddingLeft: "0px"}}>
                        <span className="form-title">Trabajadores</span>
                        <span className="form-subtitle">
                          Ingresados:{" "}
                          {steps.step2 &&
                            steps.step2.workers &&
                            steps.step2.workers.length}
                        </span>
                        <WorkersTable workers={steps.step2.workers || []} />
                      </div>
                      {/* <div>
                        <span></span>
                      </div> */}

                      {/* <div className="form-separator">
                        <hr />
                      </div> */}
                    </>
                  )}
                </React.Fragment>
              );
            })}
          </div>

          {/* <div className="cotizaciones-step3-table-resume">
            {inputs.step2.map((input) => {
              if (!steps.step2[input.name]) return;

              return (
                <React.Fragment key={input.name}>
                  <span><b>{input.label}</b></span>
                  <div>{steps.step2[input.name]}</div>
                </React.Fragment>
              );
            })}
          </div> */}
        </div>

        <FormButtons
          handleBack={() => this.handleStepUpdate({ toPreviousStep: true })}
          handleNext={this.genTextFile}
          customText={this.props.showSendingText ? "Enviando Declaración..." : "Enviar Declaración y Finalizar"}
        />
      </div>
    );
  }
}

Step3.propTypes = {
  steps: PropTypes.shape({
    currentStep: PropTypes.number,
    step1: PropTypes.object,
    step2: PropTypes.object,
    step3: PropTypes.object,
  }).isRequired,
};

Step3.defaultProps = {
  steps: {
    currentStep: 1,
    step1: {},
    step2: {},
    step3: {},
  },
};

const mapStateToProps = (state) => ({
  isOpenModalNotifCotizaciones: state.cotizaciones.isOpenModalNotifCotizaciones,
  showSendingText: state.cotizaciones.showSendingText,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => {
    dispatch(action);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Step3);
